import { Component, Input } from '@angular/core';

import { GuiaMedica } from 'src/app/shared/model/guia-medica.model';

@Component({
  selector: 'app-exportar-pdf',
  templateUrl: './exportar-guia-pdf.component.html',
  styleUrls: ['./exportar-guia-pdf.component.css']
})
export class ExportarGuiaPdfComponent {

  // Atributo com os dados para preencher o PDF.
  @Input() guiaMedica: GuiaMedica;
  @Input() subTotalProcedimentos: number;
  @Input() subTotalOutrosProcedimentos: number;

  constructor() { }
}
